<aside class="side-menu">
  <div class="side-menu__header">
    <span class="side-menu__logo">Logo</span>
    <button mat-icon-button (click)="close()">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>
  </div>

  <nav class="side-menu__nav">
    <mat-nav-list>
      @for (item of navigationItems(); track item.label) {
        @if (!item.isHidden) {
          <a
            mat-list-item
            [routerLink]="item.isDisabled ? null : item.route"
            [disabled]="!!item.isDisabled"
            (click)="onNavItemClick(item, $event)"
          >
            <mat-icon fontSet="material-icons-outlined" matListItemIcon>{{ item.icon }}</mat-icon>
            <span matListItemTitle>{{ item.label }}</span>
            @if (item.badge !== undefined) {
              <bi-notification-badge
                matListItemMeta
                [count]="item.badge"
                [pendingMode]="!!item.badgePending"
              />
            }
          </a>
          @if (item.dividerAfter) {
            <mat-divider />
          }
        }
      }
    </mat-nav-list>
  </nav>

  <div class="side-menu__footer">
    <mat-divider />
    <mat-nav-list>
      <a mat-list-item routerLink="/user-settings" (click)="close()">
        <mat-icon fontSet="material-icons-outlined" matListItemIcon>settings</mat-icon>
        <span matListItemTitle>Настройки на профил</span>
      </a>
    </mat-nav-list>
    <mat-divider />
    <div class="side-menu__user">
      <div class="side-menu__avatar">
        <mat-icon fontSet="material-icons-outlined">person</mat-icon>
      </div>
      <div class="side-menu__user-info">
        <span class="side-menu__user-name">Георги Петров</span>
        <span class="side-menu__user-email">gpetrov@gmail.com</span>
      </div>
    </div>
    @if (authStore.user()) {
      <bi-button variant="outlined" (clicked)="authStore.signOut(); close()">Изход</bi-button>
    }
  </div>
</aside>
